var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCommentGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_plane-copy-icons/24x24/ico_speech_bubble",
    fill: "#B2B2B2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33333333,13.3330664 L1.33333333,1.99973329 L14.6666667,1.99973329 L14.6666667,13.3330664 L7.60947571,13.3330664 L6,14.9425421 L4.39052429,13.3330664 L1.33333333,13.3330664 Z M2.66666667,11.9997335 L4.94280904,11.9997335 L6,13.0569245 L7.05719096,11.9997335 L13.3333333,11.9997335 L13.3333333,3.33306662 L2.66666667,3.33306662 L2.66666667,11.9997335 Z M6,7.33333302 L6,8.66666635 L4.66666667,8.66666635 L4.66666667,7.33333302 L6,7.33333302 Z M8.66666667,7.33333302 L8.66666667,8.66666635 L7.33333333,8.66666635 L7.33333333,7.33333302 L8.66666667,7.33333302 Z M11.3333333,7.33333302 L11.3333333,8.66666635 L10,8.66666635 L10,7.33333302 L11.3333333,7.33333302 Z",
    id: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCommentGray);
export default __webpack_public_path__ + "static/media/ico_comment_gray.241883e4f4622530570c01e209f79883.svg";
export { ForwardRef as ReactComponent };